export function normalizeSelectOptions(options = []) {
  return options.map((option) => option && typeof option === "object" ? {
    value: String(option.value ?? option.label ?? ""),
    label: String(option.label ?? option.value ?? ""),
    searchText: String(option.searchText ?? ""),
    disabled: Boolean(option.disabled),
  } : { value: String(option ?? ""), label: String(option ?? ""), searchText: "", disabled: false });
}
